export default __webpack_public_path__ + "51b08a9e60b1d35716153d3403160a78.svg";